/* global Swiper */
document.querySelectorAll( '.b-testimonials-slider' ).forEach( ( block ) => {

	const slider = block.querySelector( '.b-testimonials-slider .swiper' );

	if ( !slider ) {

		return null;

	}

	new Swiper( slider, {
		spaceBetween: 30,
		slidesPerView: 1.2,
		loop: false,
		navigation: {
			nextEl: block.querySelector( '.swiper-button-next' ),
			prevEl: block.querySelector( '.swiper-button-prev' ),
		},
		pagination: {
			el: block.querySelector( '.swiper-pagination' ),
			type: 'bullets',
			clickable: true
		},
		breakpoints: {
			1366: {
				slidesPerView: 2.2,
			},
			1600: {
				slidesPerView: 2.3,
			}
		},
	} );

} );
